import React from 'react';

import { useIntl } from 'react-intl';
import { Text, View } from 'react-native';

export const DeliveryTerms: React.FC<{ onOpenTerms: () => void }> = ({ onOpenTerms }) => {
  const { formatMessage } = useIntl();

  return (
    <View style={{ alignItems: 'center', justifyContent: 'center', paddingHorizontal: 16 }}>
      <Text style={{ textAlign: 'center', lineHeight: 20 }}>
        {formatMessage({
          id: 'deliveryTermsPrefix',
          defaultMessage:
            'Delivery terms and fees apply. Prices may be higher than at restaurants. ',
        })}
        <Text onPress={onOpenTerms} style={{ textDecorationLine: 'underline', color: '#000' }}>
          {formatMessage({ id: 'clickHereForDetails', defaultMessage: 'Click here for details.' })}
        </Text>
      </Text>
    </View>
  );
};
